import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { statusTextForJob } from "utils/jobStatus";

interface Props {
    job: sage.model.IJob;
}

const JobsListItem: React.FC<Props> = ({ job }) => {
    const createdAt = new Date(job.created_at);

    return (
        <Link
            className="list-group-item list-group-item-action"
            to={`/home/dashboard/jobs/${job.id}`}
            role="tab"
        >
            <div className="d-flex w-100 justify-content-between">
                <h5 className="mb-1">{job.name || "Unnamed Job"}</h5>
                <small>{moment(createdAt).fromNow()}</small>
            </div>
            <p className="mb-1">{statusTextForJob(job)}</p>
            <small>
                {job.render_animation ? "Animation" : "Image"} rendered in
                Blender {job.blender_version}
            </small>
        </Link>
    );
};

export default JobsListItem;
